import React, { useState } from "react";
import MenuForm from "./MenuForm";
import { createMenu } from "../../api/MenuService";

export default function MenuAdd() {
  const [loading, setLoading] = useState(false);

  const handleAddMenu = async (payload) => {
    setLoading(true);

    try {
      const res = await createMenu(payload);

      
      if (res?.success === false) {
        return {
          success: false,
          message: res?.message || "Validation failed",
          error: res?.error || {},
          status: res?.status,
        };
      }

      return {
        success: true,
        data: res,
      };

    } catch (error) {
      return {
        success: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
        error: error?.response?.data?.error || {},
        status: error?.response?.status,
      };
    } finally {
      setLoading(false);
    }
  };

  return (
    <MenuForm
      onSubmit={handleAddMenu}
      loading={loading}
      isEdit={false}
    />
  );
}